import {
  configureAlmostAvailableAlgo,
  configureFindNearestAlgo,
  deleteAlgorithmByConfig,
  disableAlgorithmByConfig,
  enableAlgorithmByConfig,
  getServiceAlgorithmConfigList,
  setAlgorithmPriority,
  updateAlgorithmAlmostAvailable,
  updateAlgorithmFindNearest,
} from "@/ServerActions/agorithmconfig";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useGetServiceAlgorithmList = (service_id: any) => {
  return useQuery<any>({
    queryKey: ["algorithm-list", "DotAdmin", service_id],
    queryFn: () => getServiceAlgorithmConfigList(service_id),
  });
};

export const useConfigureFindNearestAlgo = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: configureFindNearestAlgo,
    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;
      queryClient.invalidateQueries({
        queryKey: ["algorithm-list", "DotAdmin", serviceId], // ✅ CORRECT
      });
    },
    onError: (error: any) => {
      console.log(error);
    },
  });
};

export const useConfigureAlmostAvailableAlgo = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: configureAlmostAvailableAlgo,
    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;
      queryClient.invalidateQueries({
        queryKey: ["algorithm-list", "DotAdmin", serviceId], // ✅ CORRECT
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useDeleteAlgorithm = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: deleteAlgorithmByConfig,
    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;
      queryClient.invalidateQueries({
        queryKey: ["algorithm-list", "DotAdmin", serviceId], // ✅ CORRECT
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
export const useUpdateAlgorithmFindNearest = () => {
  return useMutation({
    mutationFn: updateAlgorithmFindNearest,
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateAlgorithmAlmostAvailable = () => {
  return useMutation({
    mutationFn: updateAlgorithmAlmostAvailable,
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useSetAlgorithmPriority = () => {
  return useMutation({
    mutationFn: setAlgorithmPriority,
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useEnableAlgorithm = () => {
  return useMutation({
    mutationFn: enableAlgorithmByConfig,
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useDisableAlgorithm = () => {
  return useMutation({
    mutationFn: disableAlgorithmByConfig,
    onError: (error) => {
      console.log(error);
    },
  });
};
